import React from 'react'
import Link from 'gatsby-link'

const IndexPage = () => (
  <div>
    <h1>Witajcie studenci!</h1>
    <p>Przedstawiamy BSI-Quiz, czyli narzędzie przygotowujące do egazminu z przedmiotu Bezpieczeństwo Sieci Informatycznych. Jest to remake krążącego po sieci, podejrzanego pliku exe.</p>
    <p>Projekt bazuje na bazie pytań zebranych przez starsze roczniki. Nie jesteśmy ich autorami i nie znamy ich pochodzenia, jak również ich poprawności. Autorzy nie ponoszą odpowiedzialności za potencjalną ocenę negatywną z Twojego egzaminu. Korzystasz na własną odpowiedzialność.</p>
    <Link to="/bsi/">Niechaj rozpocznie się NAUKA!</Link>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js